module.exports = __webpack_public_path__ + "img/「相続のせんせい」とは.6342430b.png";